import React, { useRef  } from 'react'; // add when enabled the contact form , useEffect
import { EMAIL, GITHUB, /*STKOVRFLW,*/ LKIN, MEDIUM, INSTAGRAM, YT } from './CustomIcon.js';
import CustomHook from './CustomHook';
import '../styles/Contacts.css';
import socials from '../data/socials.json';
// import emailjs from '@emailjs/browser';

const contactsData = socials.socials;

const iconMap = {
  EMAIL,
  GITHUB,
  LKIN,
  MEDIUM,
  INSTAGRAM,
  YT
};

function Contacts() {
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);

  // useEffect(() => {
  //   emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
    
  //   // Reset submit count after 24 hours
  //   const resetTime = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  //   const timer = setInterval(() => {
  //     setSubmitCount(0);
  //   }, resetTime);

  //   return () => clearInterval(timer);
  // }, []);

  // // Email validation using regex
  // const isValidEmail = (email) => {
  //   const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  //   return emailRegex.test(email);
  // };

  // // Content validation
  // const isSpamContent = (content) => {
  //   const spamPatterns = [
  //     /\b(viagra|cialis|casino|lottery|winner)\b/i,  // Common spam words
  //     /^[^a-zA-Z]*$/,  // Only numbers or special characters
  //     /(.)\1{4,}/      // Same character repeated 5+ times
  //   ];
  //   return spamPatterns.some(pattern => pattern.test(content));
  // };

  // const validateForm = () => {
  //   const newErrors = {};

  //   // Name validation
  //   if (formData.from_name.length < 2) {
  //     newErrors.from_name = 'Name must be at least 2 characters long';
  //   }
  //   if (formData.from_name.length > 50) {
  //     newErrors.from_name = 'Name must be less than 50 characters';
  //   }

  //   // Email validation
  //   if (!isValidEmail(formData.from_email)) {
  //     newErrors.from_email = 'Please enter a valid email address';
  //   }

  //   // Message validation
  //   if (formData.message.length < 10) {
  //     newErrors.message = 'Message must be at least 10 characters long';
  //   }
  //   if (formData.message.length > 1000) {
  //     newErrors.message = 'Message must be less than 1000 characters';
  //   }
  //   if (isSpamContent(formData.message)) {
  //     newErrors.message = 'Message contains invalid content';
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  //   // Clear error when user starts typing
  //   if (errors[name]) {
  //     setErrors(prev => ({
  //       ...prev,
  //       [name]: ''
  //     }));
  //   }
  // };

  // const checkRateLimit = () => {
  //   const now = Date.now();
  //   const timeSinceLastSubmit = now - lastSubmitTime.current;
  //   const minTimeBetweenSubmits = 60 * 1000; // 1 minute in milliseconds
  //   const maxSubmitsPerDay = 5;

  //   if (timeSinceLastSubmit < minTimeBetweenSubmits) {
  //     setStatus('error');
  //     setErrors(prev => ({
  //       ...prev,
  //       form: `Please wait ${Math.ceil((minTimeBetweenSubmits - timeSinceLastSubmit) / 1000)} seconds before sending another message`
  //     }));
  //     return false;
  //   }

  //   if (submitCount >= maxSubmitsPerDay) {
  //     setStatus('error');
  //     setErrors(prev => ({
  //       ...prev,
  //       form: 'Daily message limit reached. Please try again tomorrow.'
  //     }));
  //     return false;
  //   }

  //   return true;
  // };

  // const sendEmail = async (e) => {
  //   e.preventDefault();

  //   // Form validation
  //   if (!validateForm()) {
  //     return;
  //   }

  //   // Rate limiting
  //   if (!checkRateLimit()) {
  //     return;
  //   }

  //   setStatus('sending');

  //   try {
  //     const response = await emailjs.send(
  //       process.env.REACT_APP_EMAILJS_SERVICE_ID,
  //       process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  //       {
  //         from_name: formData.from_name,
  //         from_email: formData.from_email,
  //         to_name: formData.to_name,
  //         message: formData.message
  //       }
  //     );

  //     if (response.status === 200) {
  //       setStatus('success');
  //       setFormData({
  //         from_name: '',
  //         from_email: '',
  //         to_name: 'Shreyas',
  //         message: ''
  //       });
  //       setSubmitCount(prev => prev + 1);
  //       lastSubmitTime.current = Date.now();
  //       setTimeout(() => setStatus(''), 5000);
  //     }
  //   } catch (error) {
  //     console.error('EmailJS Error:', error);
  //     setStatus('error');
  //     setErrors(prev => ({
  //       ...prev,
  //       form: 'Failed to send message. Please try again later.'
  //     }));
  //     setTimeout(() => setStatus(''), 5000);
  //   }
  // };
  
  return (
    <section className='contacts' ref={scrollTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        Contact Me
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}>
        Feel free to contact me anytime.
      </div>

      {/* <form onSubmit={sendEmail} className="contact-form">
        <div className="form-group" ref={(el) => el && divs.current.push(el)}>
          <input
            type="text"
            name="from_name"
            value={formData.from_name}
            onChange={handleInputChange}
            placeholder="Your Name"
            required
            className={`form-input ${errors.from_name ? 'error' : ''}`}
          />
          {errors.from_name && <div className="error-message">{errors.from_name}</div>}
        </div>
        <div className="form-group" ref={(el) => el && divs.current.push(el)}>
          <input
            type="email"
            name="from_email"
            value={formData.from_email}
            onChange={handleInputChange}
            placeholder="Your Email"
            required
            className={`form-input ${errors.from_email ? 'error' : ''}`}
          />
          {errors.from_email && <div className="error-message">{errors.from_email}</div>}
        </div>
        <div className="form-group" ref={(el) => el && divs.current.push(el)}>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            placeholder="Your Message"
            required
            className={`form-input ${errors.message ? 'error' : ''}`}
            rows="5"
          />
          {errors.message && <div className="error-message">{errors.message}</div>}
        </div>
        <button 
          type="submit" 
          className="submit-btn" 
          disabled={status === 'sending' || submitCount >= 5}
          ref={(el) => el && divs.current.push(el)}
        >
          {status === 'sending' ? 'Sending...' : 'Send Message'}
        </button>
        {status === 'success' && (
          <div className="status-message success">Message sent successfully!</div>
        )}
        {errors.form && (
          <div className="status-message error">{errors.form}</div>
        )}
      </form> */}

      <div className="list" ref={(el) => el && divs.current.push(el)}>
        {contactsData.map((value, key) => (
          <div className='item' key={key}>
            <a href={value.link} target="_blank" rel="noopener noreferrer" aria-label={value.name}>
            {iconMap[value.icon] ? React.createElement(iconMap[value.icon]) : null}
          </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Contacts;